/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-get, ember/no-mixins */
import Controller from '@ember/controller';
import { service } from '@ember/service';
import EditPostMixin from '@linc-technologies/linced-common/mixins/edit-post';
import { action } from '@ember/object';

export default class PostsController extends Controller.extend(EditPostMixin) {
  // Services
  @service
  store;

  @action
  refresh() {
    this.get('model.posts').update();
  }
}
